import { useRef, useEffect, useMemo,useState} from "react";
import {
  Row,
  Col,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
  Container,
  Label
} from "reactstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min"
import FileUpload from "lib/Core/Backend/Controllers/FileUpload";
import Purchaser from "lib/Core/Backend/Controllers/Purchaser";
import DataTable from "../Core/DataTable";
import Notify from "../../lib/Utils/Alert";
import './ModalConfirm.css';
import Select from "react-select";
import NotificationAlert from "react-notification-alert";
import Spinner from 'react-bootstrap/Spinner';

const ModalConfirmInventory = ({ token, isOpen, toggle, onBack, onConfirm, addCheckoutLoading, termsShow, data = [],customerData,selectedId,setSelectedId,selectedIdTwo,setSelectedIdTwo,supplierLabel,referenceValue,preventManagerBatch,setPreventManageBatch }) => {
  const dollar = useMemo(() => Intl.NumberFormat('en-US', {
    style: "currency",
    currency: "USD",
  }), []);
  
  const [customerOption,setCustomerOption] = useState([]);
  const [customerOptionTwo,setCustomerOptionTwo] = useState([])
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsTwo,setSelectedOptionsTwo] = useState([])
  // const [selectedId,setSelectedId] = useState([])
  // const [selectedIdTwo,setSelectedIdTwo] = useState([])
  const [enableBrandValue,setEnabledBrandValue] = useState([])
  const [disableBrandValue,setDisableBrandValue] = useState([])
  const [showAllCustomer,setShowAllCsutomer] = useState([])
  
  
  
  
  const tableRealTime = useRef(null);
  const tableNotRealTime = useRef(null);
  const enableRef = useRef();
  const alert = useRef()
  const disableRef = useRef();
  const supplierCtl = useMemo(() => new FileUpload(token), [token]);
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const headerReal = [
    { title: "Name", data: "name", sortable: true },
    {
      title: "Subtotal Face Value",
      data: "subtotal",
      sortable: true,
      render: data => data ? dollar.format(data) : 0,
    },
    {
      title: "Subtotal",
      data: "total",
      sortable: true,
      render: data => data ? dollar.format(data) : 0,
    }
  ];

  const headerNotReal = [
    { title: "Name", data: "name", sortable: true },
    {
      title: "Subtotal Face Value",
      data: "subtotal",
      sortable: true,
      render: data => data ? dollar.format(data) : 0,
    },
    {
      title: "Subtotal",
      data: "total",
      sortable: true,
      render: data => data ? dollar.format(data) : 0,
    }
  ];

  const dataRealTime = data.filter((item) => item.edt === 0);
  const dataNotRealTime = data.filter((item) => item.edt > 0);

  useEffect(() => {
    if (tableRealTime.current) {
      tableRealTime.current.dataTable.clear().rows.add(dataRealTime).draw();
    }
    if (tableNotRealTime.current) {
      tableNotRealTime.current.dataTable.clear().rows.add(dataNotRealTime).draw();
    }
  }, [data]);

  const downloadTermsandCondition = (url) => {
    const link = Object.assign(document.createElement('a'), { href: url, download: '', target: '_blank' });
    document.body.appendChild(link).click();
    document.body.removeChild(link);
  };

  const downloadFile = (FileType) => {
    supplierCtl.downloadPDFDocument(FileType, (data) => {
      if (data && !data.error) {
        downloadTermsandCondition(data?.link);
      } else {
        Notify(alert, "danger", data.error);
      }
    });
  };
useEffect(()=>{
  if(customerData){
const options  = customerData.map((item)=>({
     value :item.id,
     label:item.name
    }));
    setShowAllCsutomer(options)
    const allCustomersOption = {
      value: 'all',
      label: 'All Customers',
    };
    const allnotEnable = {
      value:'alldisable',
      label:'All Customer Not enabled'
    }
    setCustomerOption([allCustomersOption, ...options])
    setCustomerOptionTwo([allnotEnable,...options])
  }
},[customerData])

const handleSelectChange = (selectedOption) => {
  const values = selectedOptionsTwo.map(item=>item.value)
  if (values.length === showAllCustomer.length) {
    Notify(alert, "danger", "You cannot select any options in the disable dropdown when 'All Customers' is selected.");
    return; // Prevent further execution
  }
  if(values.includes(selectedOption.value)){
    Notify(alert,"danger","You can not select same option for both the eenable and disable")
    return;
  }
  setEnabledBrandValue(selectedOption)
  const id = selectedOption.value
  if (id === 'all') {
    setPreventManageBatch(true)
     
  } else {
    setPreventManageBatch(false)
    // If "All Customers" is not selected, handle other selections
    setSelectedOptions([selectedOption]);
    setSelectedId([id])
    if (selectedOption && !selectedOptions.some(opt => opt.value === selectedOption.value)) {
      // Add the selected option to the state only if it's not already selected
      setSelectedOptions([...selectedOptions, selectedOption]);
      setSelectedId([...selectedId, id]);
    }
  }
};

const handleSelectdiableChange = (selectedOption) => {
  const values =  selectedOptions.map(item=>item.value)
  if (values.length === showAllCustomer.length) {
    Notify(alert, "danger", "You cannot select any options in the disable dropdown when 'All Customers' is selected.");
    return; // Prevent further execution
  }
  if(values.includes(selectedOption.value)){
    Notify(alert,"danger","You can not select same option for both the eenable and disable")
    return;
  }
 
  setDisableBrandValue(selectedOption)
  const id = selectedOption.value
  if(id === 'alldisable'){
    const remainingCustomers = showAllCustomer.filter(customer => !values.includes(customer.value));
    setSelectedOptionsTwo(remainingCustomers);
   const allid = remainingCustomers.map(item=>item.value)
   setSelectedIdTwo(allid);
  }else{
    setSelectedOptionsTwo([selectedOption])
    setSelectedIdTwo([id])
    if (selectedOption && !selectedOptionsTwo.some(opt => opt.value === selectedOption.value)) {
      // Add the selected option to the state only if it's not already selected
      setSelectedOptionsTwo([...selectedOptionsTwo, selectedOption]);
      setSelectedIdTwo([...selectedIdTwo,id])
    }
  }
 
};

// Handle removing an option
const handleRemoveOption = (optionToRemove) => {
  setSelectedId(selectedId.filter(opt=>opt !== optionToRemove.value))
  setSelectedOptions(selectedOptions.filter(opt => opt.value !== optionToRemove.value));
};

const handleRemoveDisaleOption = (optionToRemove) => {
  setSelectedIdTwo(selectedIdTwo.filter(opt=>opt !== optionToRemove.value))
  setSelectedOptionsTwo(selectedOptionsTwo.filter(opt => opt.value !== optionToRemove.value));
};



  return (
    <>
    <NotificationAlert ref={alert}/>
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      backdrop="static"
      centered={true}
      size="xl"
      style={{ maxWidth: "85% !important" }}
    >
      <ModalHeader className="custom_header_colourTwo align-items-center">
        <h5 style={{ margin: 0, fontSize:'20px' }}>Confirm order</h5>
      </ModalHeader>
      <ModalBody className="m-5">
        
        <Row>
          <Col xs="12">
            <h2 className="text-center mb-3"><span className="pb-1" style={{ borderBottom: '2px solid black' }}>Check your order</span></h2>
          </Col>
        </Row>
        <Row style={{marginLeft:"0px"}}>
          <Col xs="12">
            <p style={{fontSize:"17px",fontWeight:"600"}}>Supplier: {supplierLabel}</p>
            <p style={{fontSize:"17px",fontWeight:"600"}}>Reference Number: {referenceValue}</p>
          </Col>
        </Row>
        <Row>
          <Col xs="6">
            <Container>
              <h4>Real time orders</h4>
              <DataTable
                className="mb-0 no-bottom-radius j_add_order_table"
                options={{
                  dom: "t", 
                  responsive: true, 
                  scrollY: '20vh',
                  pageLength: -1,
                }}
                ref={tableRealTime}
                columns={headerReal}
                data={dataRealTime}
                enableSelectFilters={true}
              />
            </Container>
          </Col>
          <Col xs="6" className="mt-3">
              <div className="col-12 mb-3 p-0" style={{display:'flex', justifyContent: "flex-end", alignItems:"flex-end", flexDirection:"column"}}>
                 
                  <div className="col-12 d-flex justify-content-between p-0">
                    <h5 className="m-0 align-items-center d-flex">Enable To</h5>
                    <Select
                    placeholder="Select..."
                    ref={enableRef}
                    options={customerOption}
                    value={enableBrandValue}
                    onChange={handleSelectChange}
                    className="col-6 p-0"
                    />
                  </div>
              </div>
              <div
                style={{
                  border: '1px solid #ccc',
                  padding: '20px',
                  minHeight: '100px',
                  maxHeight:"202px",
                  overflow:"auto",
                  backgroundColor: '#f9f9f9',
                }}
              >
                <h6>Selected Options:</h6>
                {selectedOptions.length === 0 && preventManagerBatch === false ? (
                  <p>No options selected</p>
                ) : preventManagerBatch === true ? (
                  <p>All customers have been enabled</p>
                ) : (
                  selectedOptions.map((option) => (
                    <div
                      key={option.value}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '10px',
                        padding: '3px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                      }}
                      className="col-5"
                    >
                      <span>{option.label}</span>
                      <button
                        onClick={() => handleRemoveOption(option)}
                        style={{
                          marginLeft: '10px',
                          background: 'red',
                          color: 'white',
                          border: 'none',
                          padding: '5px 10px',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                      >
                        X
                      </button>
                    </div>
                  ))
                )}
              </div>
          </Col>
        </Row>
        <Row>
          <Col xs="6" className="mt-4">
            <Container style={{ marginTop: "20px" }}>
              <h4>Non-Real time orders</h4>
              <DataTable
                className="mb-0 no-bottom-radius j_add_order_table"
                options={{
                  dom: "t", 
                  responsive: true,
                  scrollY: '20vh',
                  pageLength: -1,
                }}
                ref={tableNotRealTime}
                columns={headerNotReal}
                data={dataNotRealTime}
                enableSelectFilters={true}
              />
            </Container>
          </Col>
          {/* <Col xs="3">
          </Col>
          <Col xs="3" className="mt-5">
          <Label>Disable Batch</Label>
          <Select 
          placeholder="Select..."
          ref={disableRef}
          options={customerOption}
          />
          <p></p>
          </Col> */}
          <Col xs="6" className="mt-5">
          {preventManagerBatch === true ? ""
          :
          
            <>
              <div className="col-12 mb-3 p-0" style={{display:'flex', justifyContent: "flex-end", alignItems:"flex-end", flexDirection:"column"}}>
                  
                  <div className="col-12 d-flex justify-content-between p-0">
                    <h5 className="m-0 align-items-center d-flex">Disable To</h5>
                    <Select
                    placeholder="Select..."
                    ref={enableRef}
                    options={customerOptionTwo}
                    value={disableBrandValue}
                    onChange={handleSelectdiableChange}
                    className="col-6 p-0"
                    />
                  </div>
              </div>
              <div
                style={{
                  border: '1px solid #ccc',
                  padding: '20px',
                  minHeight: '100px',
                  maxHeight:"202px",
                  overflow:"auto",
                  backgroundColor: '#f9f9f9',
                }}
              >
                <h6>Selected Options:</h6>
                {selectedOptionsTwo.length === 0 ? (
                  <p>No options selected</p>
                ) : (
                  selectedOptionsTwo.map((option) => (
                    <div
                      key={option.value}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '10px',
                        padding: '3px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                      }}
                      className="col-5"
                    >
                      <span>{option.label}</span>
                      <button
                        onClick={() => handleRemoveDisaleOption(option)}
                        style={{
                          marginLeft: '10px',
                          background: 'red',
                          color: 'white',
                          border: 'none',
                          padding: '5px 10px',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                      >
                        X
                      </button>
                    </div>
                  ))
                )}
              </div>
              </>
           }
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className="modalFooter">
        {termsShow === false || termsShow === undefined ? (
          <>
            <div className="termsAndConditions">
              By clicking Confirm, you accept the 
              <div className="linkContainer">
                <Link to={"terms"} target="_blank" onClick={(e) => { e.preventDefault(); downloadFile('TERMS') }}> Terms of Use </Link> and 
                <Link to={"privacy"} target="_blank" onClick={(e) => { e.preventDefault(); downloadFile('PRIVACY') }}> Privacy Policy</Link>
              </div>
            </div>
          </>
        ) : ""}
        <div className="buttons">
          <Button color="secondary" onClick={onBack}>
            Back
          </Button>
          <Button className="btn btn-primaryTwo" onClick={onConfirm} disabled={addCheckoutLoading}> 
            {!addCheckoutLoading && "Confirm"} {addCheckoutLoading && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
    </>
  );
};

export default ModalConfirmInventory;
